<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :cancelButtonProps="{ props: {disabled: true} }"
    :footer="null"
  >
    <a-form :form="form" :class="status == 1 ? 'readyOnly':''">
      <a-form-item style="display:none">
        <a-input v-decorator="['id']"/>
      </a-form-item>
      <!--<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">-->
        <!--<a-select  v-decorator="['installType',{ rules: [{ required: true, message: '安装类别' }] }]">-->
          <!--<a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>-->
        <!--</a-select>-->
      <!--</a-form-item>-->
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装信息">
        <a-input v-decorator="['installationInfoName', {rules: [{ required: true, message: '请输入安装信息'}]}]"/>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字段类型">
        <a-select v-decorator="['fieldType',{ rules: [{ required: true, message: '请输入字段类型' }] }]" @change="handselect">
          <a-select-option  v-for="(val,key) in fieldType" :key="key" :value="key">{{val}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字段取值" v-if="isShow == true">

        <a-select   v-decorator="['fieldValue',{ rules: [{ required: true, message: '请输入字段取值' }] }]"
                   showSearch
                   :filterOption="filterOption"
                   allowClear="true">
          <a-select-option  v-for="type in data1" :key="type.dictType">{{type.dictName}}</a-select-option>
        </a-select>

      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否回传">
        <a-select v-decorator="['isBack',{ rules: [{ required: true, message: '请输入是否回传' }] }]">
          <a-select-option value="0">是</a-select-option>
          <a-select-option value="1">否</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否必填">
        <a-select v-decorator="['isMust',{ rules: [{ required: true, message: '请输入是否必填' }] }]">
          <a-select-option value="0">是</a-select-option>
          <a-select-option value="1">否</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <a-row :class="status == 1 ? 'readyOnly':''">
      <a-col :span="10"></a-col>
      <a-col :span="12">
        <a-button @click="handleSubmit" type="primary" style="margin-right: 10px">保存</a-button>
        <a-button @click="showModal">取消</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
  import { saveChannel,fieldType,save,update,getList } from '@/api/basicdatas/Orderinstallinfo'
  import pick from 'lodash.pick'
  import { getDictMap } from '../../../utils/dict'

  export default {
    name: 'BrandModal',
    props: {
    },
    components: {
    },
    data () {
      return {
        queryParam: {},
        visible: false,
        // restaurantOperTypeMap: {},
        // restaurantTypes: [],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        mdl: {},
        form: this.$form.createForm(this),
        data:[],
        fieldType,
        course:'',
        data1:[],
        status:0,
        isShow:true
      }
    },
    beforeCreate () {
    },
    // filters: {
    //   fieldFilter (value) {
    //     return fieldType[value]
    //   },
    // },
    async created () {
      // this.restaurantTypes = [];
      // this.restaurantOperTypeMap = await getDictMap('install_type');
      // this.restaurantOperTypeMap.forEach((value, key) => {
      //   // console.log(value,key)
      //   this.restaurantTypes.push({code: key, label: value})
      // })
      getList().then(res=>{
        this.data1=res.rows
      })
    },
    mounted () {
    },
    methods: {

      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );

      },

      showModal () {
        this.visible = !this.visible
      },
      handleChange (value) {
        // console.log(`selected ${value}`)
        this.queryParam.enterpriseId= value
      },
      add () {
        this.form.resetFields()  //清空
        this.course = 0
        this.isShow = true
        this.visible = true
      },
      edit (record,status) {
        this.form.resetFields()
        this.course=1
        this.status = status
        this.mdl = Object.assign(record)
        // console.log(record)
        this.visible = true
        if( record.fieldType == 1 ){
          this.isShow = false
        }else{
          this.isShow = true
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.mdl, 'id','installationInfoName','fieldType','fieldValue','enterpriseName','isBack','isMust'))
        })
      },
      handselect(value){
        // console.log(value)
        if(value == 1){
          this.isShow = false
        }else{
          this.isShow = true
        }
      },
      handleSubmit (e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            // console.log('Received values of form: ', values)
            this.confirmLoading = true
            if (this.course==0){
              save(values).then(res => {
                // console.log(values)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok',1)
                  this.visible = false
                } else {
                  this.$message.error(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              }).finally(() => {
                this.confirmLoading = false
              })
            } else if (this.course==1){
              update(values).then(res => {
                // console.log(values)
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok',2)
                  this.visible = false
                } else {
                  this.$message.error(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              }).finally(() => {
                this.confirmLoading = false
              })
            }
          }
        })
      },
    },
    watch: {
      /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
    }
  }
</script>
<style scoped>
  .readyOnly{
    pointer-events: none;
  }
</style>
